<template>
	<div class="loader-wrapper">
		<div class="loader-wrapper-container" v-if="isLoading || !destroyLoader" :class="{ 'is-show': isLoading }">
			<Loader />
		</div>

		<slot v-if="!isLoading" />
	</div>
</template>

<script>
export default {
	name: 'LoaderWrapper',
	props: {
		isLoading: { type: Boolean },
	},
	created() {
		this.destroyLoader = false || !this.isLoading;
	},
	watch: {
		isLoading: {
			handler(newV) {
				if (newV) {
					this.destroyLoader = !newV;
				} else {
					setTimeout(() => {
						this.destroyLoader = !newV;
					}, 500);
				}
			},
		},
	},
	data: () => ({
		destroyLoader: false,
	}),
};
</script>

<style scoped lang="scss">
.loader-wrapper {
	$transition-time: 0.5s; // sync with setTimeout

	position: relative;
	width: 100%;

	.loader-wrapper-container {
		position: absolute;
		top: 0;
		left: 0;
		height: 100%;
		width: 100%;
		background: #f9f9f9; //var(--bg-color); // Todo: this is not good enough - bg-color will not be suiteable for all
		border-radius: 10px;
		z-index: 999;

		&.is-show {
			opacity: 1;
			transition: 0.5s;
		}
		&:not(.is-show) {
			opacity: 0;
			transition: 0.5s;
		}
	}
}
</style>
